import { AlertTriangle } from 'lucide-react';

interface ErrorFallbackProps {
  label?: string;
}

export function ErrorFallback({ label }: ErrorFallbackProps) {
  return (
    <div className="flex flex-col items-center justify-center p-8 bg-red-50 rounded-lg border border-red-200 text-red-800 gap-4 min-h-[200px]">
      <AlertTriangle className="w-10 h-10 text-red-500 mb-2" />
      {label && (
        <pre className="bg-red-100 rounded p-2 text-sm text-red-700 max-w-xl overflow-auto border border-red-200">
          {label}
        </pre>
      )}
    </div>
  );
}
